<div class="modal-backdrop" *ngIf="show" (click)="onBackdropClick($event)">
  <div
    class="modal-dialog modal-dialog-centered"
    (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-body">
        <div class="text-center">
          <!-- Template Icon -->
          <div class="template-icon-container mb-4">
            <div class="template-icon-background">
              <i class="fas fa-file-alt"></i>
            </div>
          </div>

          <!-- Main Message -->
          <h5 class="modal-title mb-3">
            You're about to create a new service using the "{{ templateName }}"
            template.
          </h5>

          <!-- Info Message -->
          <p class="info-message text-muted">
            This will take you to the service creation form, pre-filled with<br />
            the settings and details from this template.
          </p>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="onCancel()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">
          Proceed
        </button>
      </div>
    </div>
  </div>
</div>
